<template>
	<ul class="zl-step">
		<li :class="{cur:active>=index}" v-for="(item,index) in stepArr" :style="{
            width:width,
            color:active>=index?color||'#fff':'#000',
            'background':active>=index?background||'#0147eb':'#f5f6fa'
        }" :key="index"><span>{{index +1}}</span>
			<span>{{item.title}}</span>
			<div v-if="index<stepArr.length-1" :class="active>=index?'jiaoActive':'jiao'" :style="{
                color:active>=index?color||'#fff':'#000',
                'border-left-color':active>=index?background||'#0147eb':'#f5f6fa'
            }"></div>
			<div class="interval"></div>
		</li>
	</ul>

</template>

<script>
	export default {
		name: 'ZlStep',
		props: {
			active: {
				type: Number,
				default: 0
			},
			stepArr: {
				type: Array,
				default: () => []
			},
			width: {
				type: String,
				default: '100%'
			},
			background: {
				type: String,
				default: '#0147eb'
			},
			color: {
				type: String,
				default: '#fff'
			},
			height: {
				type: String,
				default: '40px'
			}
		},
		watch: {
			active(a) {
				if (a <= 0) {
					this.$emit('update:active', 0);
					console.log('已经是最小值了' + a);
				}
				if (a > this.stepArr.length - 1) {
					this.$emit('update:active', this.stepArr.length - 1);
					console.log('已经是最大值了' + a);
				}
			}
		},
		data() {
			return {

			};
		}
	};
</script>

<style lang="less" scoped>
	.zl-step {
		list-style: none;
		font-size: 14px;
		height: 40px;
		display: flex;
		justify-content: center;
		align-items: center;
		overflow: hidden;
	}

	li {
		height: 40px;
		background: #d7d8da;
		color: #666;
		text-align: center;

		line-height: 40px;
		font-weight: 500;
		/*width: 20%;*/
		/*flex-basis: 100%;*/
		position: relative;

		span:nth-child(1) {
			font-size: 16px;
			font-weight: bold;
			line-height: 17px;
			margin-right: 10px;
		}
	}

	/*三角形绘制*/
	.jiao {
		width: 0;
		height: 0;
		border-top: 20px solid transparent;
		/*高度一半*/
		border-left: 20px solid #d7d8da;
		/*调整宽度*/
		border-bottom: 20px solid transparent;
		/*高度一半*/
		position: absolute;
		right: -20px;
		/*跟宽度保持一致*/
		top: 0;
		z-index: 9999;
	}

	.jiaoActive {
		width: 0;
		height: 0;
		border-top: 20px solid transparent;
		/*高度一半*/
		border-left: 20px solid #E8514A;
		/*调整宽度*/
		border-bottom: 20px solid transparent;
		/*高度一半*/
		position: absolute;
		right: -20px;
		/*跟宽度保持一致*/
		top: 0;
		z-index: 2;
	}

	/*大3个px的边 26-20/2*/
	.interval {

		width: 0;
		height: 0;
		border-top: 26px solid transparent;
		/*高度一半*/
		border-left: 26px solid #ffffff;
		/*调整宽度*/
		border-bottom: 26px solid transparent;
		/*高度一半*/
		position: absolute;
		right: -26px;
		/*跟宽度保持一致*/
		top: -6px;
		z-index: 1;
	}
</style>
